import {
  defineStyle,
  defineStyleConfig,
  SystemStyleObject,
} from '@chakra-ui/react';
import { getTypographyToken } from '@allergan-data-labs/alle-elements-core';

export const getToolTipTitleStyles = (): SystemStyleObject => ({
  margin: 0,
  ...getTypographyToken('Body/Small/Medium'),
  fontWeight: 'Semibold',
});

const baseStyle = defineStyle((props) => {
  const { colorScheme: c } = props;
  return {
    ...getTypographyToken('Body/Small/Medium'),
    fontWeight: 'Regular',
    p: '12',
    borderRadius: 'Small',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    maxW: '375px',
    minH: '21px',
    boxShadow: 'Elevation/2',
    zIndex: 'tooltip',
    color: `${c}.Text/Neutral/Inverted`,
    bg: `${c}.Container/Neutral/Interactive/Enable`,
  };
});

export const TooltipTheme = defineStyleConfig({
  baseStyle,
});
